import { Theme } from '@emotion/react';

export const DarkTheme = {
  light: false,
  layout: {
    background: '#0e0f10',
    background_transparent: 'rgba(14,15,16,0)',
    border: '#26292c',
    sidebar_background: '#0e0f10'
  },
  text: {
    primary: '#fff',
    secondary: '#363636',
    special: '#a514f7'
  },
  forms: {
    label: '#fff',
    error: '#ff3e3e',
    background: 'rgba(26,26,26,0.9)',
    border: 'rgb(71,71,71)',
    foreground: '#fff',
    option_hover: 'rgba(38,38,38,0.9)',
    option_selected: 'rgb(85,85,85)'
  },
  user_notification: {
    background: 'rgba(26,26,26,0.9)',
    foreground: '#fff'
  },
  notification_success: {
    background: '#00a924',
    foreground: '#fff'
  },
  notification_error: {
    background: '#ff3e3e',
    foreground: '#fff'
  },
  button_primary: {
    background: '#a514f7',
    background_hover: '#b52fff',
    foreground: '#fff'
  },
  button_secondary: {
    background: '#474747',
    background_hover: '#5c5c5c',
    foreground: '#fff'
  }
} as Theme;
